/** @format */

import apiSlice from './api-slice';

// apiSlice.enhanceEndpoints({
//    addTagTypes: ['User'],
// });
export const zaloApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    zaloLogin: builder.mutation({
      query: (params) => ({
        url: '/zalo/login',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['Zalo', 'Account']
    }),
    getUserList: builder.query({
      query: (params) => ({
        url: `/zalo/userList`,
        method: 'GET',
        params: params
      }),
      providesTags: ['User']
    }),
    test: builder.query({
      query: (params) => ({
        url: `/zalo/callback`,
        method: 'GET',
        params: params
      })
    }),
    sendMessage: builder.mutation({
      query: (params) => ({
        url: '/zalo/sendMessage',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['Zalo']
    })
  }),
  overrideExisting: false
});

export const { useZaloLoginMutation, useSendMessageMutation, useLazyGetUserListQuery, useLazyTestQuery } = zaloApi;
